module.exports = __webpack_public_path__ + "static/img/338_phase_function_Paper_Points.04871ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/338_phase_function_Paper_Points.png
// module id = SXci
// module chunks = 0